import type { IcaoCategory } from '../../../../types/mapEngine';

import catBSvg from './cat-b.svg?raw';
import catCSvg from './cat-c.svg?raw';
import catDSvg from './cat-d.svg?raw';
import catESvg from './cat-e.svg?raw';
import catFSvg from './cat-f.svg?raw';

export const AIRCRAFT_SILHOUETTES: Record<IcaoCategory, string> = {
  B: catBSvg,
  C: catCSvg,
  D: catDSvg,
  E: catESvg,
  F: catFSvg,
};

export function svgToDataUrl(svg: string): string {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
